/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react-perf/jsx-no-new-object-as-prop */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useCallback, useState } from 'react'
import {
  CouponMessageList,
  CouponErrorListItem,
  CouponValidMessage,
} from './CouponInputWmo.css'
import CouponFullInputWmo from './CouponFullInputWmo'

const CouponInputWmo = ({
  applyCouponHandler,
  enterCouponHandler,
  isCouponEmpty,
  errorMessages,
  errorMessage,
  coupon,
  modifiers,
  isValidCoupon,
  validMessage,
  hasError,
  // eslint-disable-next-line arrow-body-style
}) => {
  const [isTyping, setIsTyping] = useState(false)

  const applyCoupon = useCallback(event => { applyCouponHandler(event, modifiers) }, [applyCouponHandler, modifiers])
  const keyUpHandler = useCallback(event => { if (event.key === 'Enter') applyCoupon(event) }, [applyCoupon])
  const changeHandler = useCallback(event => {
    setIsTyping(true)
    enterCouponHandler(event)
  }, [enterCouponHandler])

  // consolidate messages into a single array and reverse for chronological order
  const combinedMessages = [
    ...validMessage ? [{ message: validMessage, type: 'valid' }] : [],
    ...errorMessage ? [{ message: errorMessage, type: 'error' }] : [],
    ...errorMessages.map((msg: { code: string; message: string }) => ({
      ...msg,
      type: 'error',
    })),
  ].reverse()

  return (
    <>
      <CouponFullInputWmo
        coupon={coupon}
        keyUpHandler={keyUpHandler}
        changeHandler={changeHandler}
        isCouponEmpty={isCouponEmpty}
        applyCoupon={applyCoupon}
        hasError={hasError}
        isValidCoupon={isValidCoupon}
        isTyping={isTyping}
        setIsTyping={setIsTyping}
      />
      <CouponMessageList style={{ margin: '0px', paddingLeft: '0px' }}>
        {combinedMessages.map((message, liIndex) => {
          if (message.type === 'valid') {
            return (
              <CouponValidMessage
                key={liIndex.toString()}
                style={{ margin: '0px' }}
              >
                * {message.message}
              </CouponValidMessage>
            )
          }

          if (message.type === 'error') {
            return (
              <CouponErrorListItem
                key={liIndex.toString()}
                dangerouslySetInnerHTML={{ __html: `* ${message.message}` }}
                style={{ margin: '0px' }}
              />
            )
          }

          return null
        })}
      </CouponMessageList>
    </>
  )
}

export default CouponInputWmo
